import * as React from 'react';
import { Link } from 'react-router-dom';

import Button, { ButtonProps } from '@/components/elements/Button/BaseButton';
import { SYLLABARY } from '@/config/constants';

import { Row } from './style';

interface SyllabarySelectorProps {
  disabledWords?: string[];
  hasLink?: boolean;
  redirectTo?: (syllabary: string[]) => string;
  onSelect?: (syllabary: string[]) => void;
}

const SyllabarySelector: React.FC<SyllabarySelectorProps> = ({
  disabledWords = [],
  hasLink = false,
  redirectTo = () => '',
  onSelect = () => {},
}): JSX.Element => {
  const disabled = (strings: string[]) => disabledWords.includes(strings[0]);

  const getButtonProps = (strings: string[]) => {
    return {
      outline: true,
      bgColor: 'secondary',
      size: 'm',
      type: 'button',
      disabled: disabled(strings),
      onClick: () => onSelect(strings),
    } as ButtonProps;
  };

  return (
    <>
      {SYLLABARY.map((lines, i: number) => (
        <Row key={i}>
          {lines.map((s, j: number) =>
            s[0].length ? (
              <React.Fragment key={s[0]}>
                {hasLink && !disabled(s) ? (
                  <Link to={redirectTo(s)}>
                    <Button {...getButtonProps(s)}>{s[0]}</Button>
                  </Link>
                ) : (
                  <Button {...getButtonProps(s)}>{s[0]}</Button>
                )}
              </React.Fragment>
            ) : (
              <div key={j} />
            ),
          )}
        </Row>
      ))}
    </>
  );
};

export default SyllabarySelector;
